import { Component } from 'react';

import {
    ValueSets
} from '@complion/query';

const {
    FixedValue,
    ValueList,
    ScalarValue,
    SelectList,
    MultiselectList,
    DataSourceSingleValue,
    DataSourceMultipleValue,
    DataSourceValueList,
    DatasetFixedValue,
    DatasetValueList,
    DatasetSingleValue,
    DatasetMultiselectList
} = ValueSets;

function Dummy() {
    return (
        <span>
            Invalid Value Set Type
        </span>
    );
}

import FixedValueComponent from 'binder/components/BinderSetup/ValueSets/FixedValue/FixedValue';
import ValueListComponent from 'binder/components/BinderSetup/ValueSets/ValueList/ValueList';
import ScalarValueComponent from 'binder/components/BinderSetup/ValueSets/ScalarValue/ScalarValue';
import SelectListComponent from 'binder/components/BinderSetup/ValueSets/SelectList/SelectList';
import MultiselectListComponent from 'binder/components/BinderSetup/ValueSets/MultiselectList/MultiselectList';
import DataSourceSingleValueComponent from 'binder/components/BinderSetup/ValueSets/DataSourceSingleValue/DataSourceSingleValue';
import DataSourceMultipleValueComponent from 'binder/components/BinderSetup/ValueSets/DataSourceMultipleValue/DataSourceMultipleValue';
import DataSourceValueListComponent from 'binder/components/BinderSetup/ValueSets/DataSourceValueList/DataSourceValueList';

const ValueSetComponentMapping = {
    [FixedValue.name]: FixedValueComponent,
    [ValueList.name]: ValueListComponent,
    [ScalarValue.name]: ScalarValueComponent,
    [SelectList.name]: SelectListComponent,
    [MultiselectList.name]: MultiselectListComponent,
    [DataSourceSingleValue.name]: DataSourceSingleValueComponent,
    [DataSourceMultipleValue.name]: DataSourceMultipleValueComponent,
    [DataSourceValueList.name]: DataSourceValueListComponent,
    [DatasetFixedValue.name]: FixedValueComponent,
    [DatasetValueList.name]: ValueListComponent,
    [DatasetSingleValue.name]: SelectListComponent,
    [DatasetMultiselectList.name]: MultiselectListComponent,
};

class ValueSetFactory extends Component {
    render() {
        const {
            valueSetName,
            groupId
        } = this.props;

        const ValueSetComponent = ValueSetComponentMapping[valueSetName] || Dummy;

        return (
            <ValueSetComponent
                key={groupId}
                { ...this.props } />
        );
    }
}

export default ValueSetFactory;
